// 投稿一覧ページャー設定
document.addEventListener('DOMContentLoaded', function() {
    // ページ全体のDOM構築が終わったら、クリックイベントリスナーを追加
    document.body.addEventListener('click', function(e) {
        var btn = e.target;
        // 投稿一覧のページネーションのボタンの場合
        if (btn.classList.contains('lpcb-latest-post-front-pagination-btn') && !btn.disabled) {
            e.preventDefault(); //ボタンのデフォルト動作を防ぐ
            // ページ番号を取得する
            var page = Number(btn.dataset.page);
            // ブロックのattributeのページ番号を書き換える
            var wrapper = btn.closest('.wp-block-lpc-blocks-latest-post-front');
            if (!wrapper) return;
            var attributes = JSON.parse(wrapper.dataset.attributes);
            attributes.lpcb_page = page; // ここでページ番号のみ追加
            // アンカーを取得
            var anchorId = attributes.anchor_id || null;

            // リクエスト
            fetch(window.lpcbLatestPostFrontAjaxVars.ajaxUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: 'action=lpcb_latest_post_front'
                    + '&attributes=' + encodeURIComponent(JSON.stringify(attributes))
                    + '&nonce=' + encodeURIComponent(window.lpcbLatestPostFrontAjaxVars.nonce)
            })
            .then(function(res){ return res.text(); })
            .then(function(html){
                // 置き換え
                wrapper.outerHTML = html;
                // スクロール（モバイル対応）
                setTimeout(function(){
                    if(anchorId){
                        var anchor = document.getElementById(anchorId);
                        if(anchor){
                            var top = anchor.getBoundingClientRect().top + window.scrollY - 60; // 60px余白
                            window.scrollTo({ top: top, behavior: 'smooth' });
                        }
                    }
                }, 10);
            })
            .catch(function(){
                wrapper.innerHTML = '<div class="lpcb-error">読み込みに失敗しました</div>';
            });
        }
    });
});
